import { Component, h } from 'preact'
import Header from '../header'
import { GroupData, ImageData } from './Overview'
import Axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'
import GroupInfoPanel from './GroupInfoPanel'
import GroupVisibilityPanel from './GroupVisibilityPanel'
import GroupFeaturedTopics, { featuredTopicsInfoType } from './GroupFeaturedTopics'

const PUBLIC_GROUP = 4

interface Props {}

interface State extends GroupData {
  src: null | string,
  crop: {
    x: number,
    y: number,
    width: number,
    height: number,
    aspect: number
  },
  pixelCrop: {
    width: number,
    height: number,
    x: number,
    y:number
  },
  isLoading: boolean,
  messageType: null |'success'| 'error',
  titleError: string,
  descriptionError: string,
  groupType:number,
  featuredTopicsInfo: featuredTopicsInfoType
}

export class GroupAdd extends Component<Props, State> {
  constructor () {
    super()

    this.state = {
      title: '',
      description: '',
      heroImage: null,
      thumbnailImage: null,
      src: null,
      crop: {
        x: 0,
        y: 0,
        width: 120,
        height: 60,
        aspect: 2
      },
      pixelCrop: {
        width: 120,
        height: 60,
        x: 0,
        y: 0
      },
      isLoading: false,
      messageType: null,
      titleError: '',
      descriptionError: '',
      groupType: PUBLIC_GROUP,
      featuredTopicsInfo: {
        title: '',
        featuredTopics: []
      }
    }

    this.onSave = this.onSave.bind(this)
  }

  async onSave () {
    let errors: {
      title?: string,
      description?: string
    } = {}
    if (this.state.title === '') {
      errors.title = 'Please fill in this field'
    }

    if (this.state.description === '') {
      errors.description = 'Group description can’t be blank'
    }

    if (Object.keys(errors).length) {
      this.setState({
        titleError: errors.title || '',
        descriptionError: errors.description || ''
      })

      return
    }

    this.setState({ isLoading: true, messageType: null })
    try {
      const { data }: { data: { id: string } } = await Axios.post('/platform/group/add', {
        title: this.state.title,
        description: this.state.description,
        heroImage: this.state.heroImage,
        groupType: this.state.groupType,
        contentCuration: {
          title: this.state.featuredTopicsInfo.title,
          curatedTopics: this.state.featuredTopicsInfo.featuredTopics.map(featuredTopic => featuredTopic.id)
        },
        thumbnailImage: this.state.thumbnailImage
      })

      if (data.id) {
        window.location.assign(`/platform/group/${data.id}?success=true`)
      }
    } catch (err) {
      this.setState({
        isLoading: false,
        messageType: 'error'
      })
    }
  }

  render (_: Props, {
    title,
    description,
    heroImage,
    thumbnailImage,
    isLoading,
    messageType,
    titleError,
    descriptionError,
    groupType,
    featuredTopicsInfo
  }: State) {
    return (
      <div className='group-add-page'>
        <Header
          title='Add group'
          isLoading={isLoading}
          saveCallback={this.onSave}
          cancelCallback={() => window.location.assign('/platform/groups')}
        />
        { messageType ? <AlertComponent sticky messageType={messageType} isVisibleFor={3000} /> : null }
        <GroupInfoPanel
          title={title}
          updateTitle={(title: string) => this.setState({ title: title, titleError: '' })}
          description={description}
          updateDescription={(description: string) => this.setState({ description: description, descriptionError: '' })}
          heroImage={heroImage}
          thumbnailImage={thumbnailImage}
          updateHeroImage={(heroImage: ImageData|null) => this.setState({ heroImage: heroImage })}
          updateThumbnailImage={(thumbnailImage: ImageData|null) => this.setState({ thumbnailImage: thumbnailImage })}
          titleError={titleError}
          descriptionError={descriptionError}
        />
        <GroupVisibilityPanel
          currentType={groupType}
          onUpdate={(option, value) => this.setState({ groupType: value })}
          />
        <GroupFeaturedTopics
          title={featuredTopicsInfo ? featuredTopicsInfo.title : ''}
          featuredTopics={featuredTopicsInfo ? featuredTopicsInfo.featuredTopics : []}
          onCallback={(featuredTopicsInfo: featuredTopicsInfoType) => this.setState({ featuredTopicsInfo: featuredTopicsInfo })}
        />
      </div>
    )
  }
}

export default GroupAdd
